import { z } from "zod";
/**
 * ADR-029 one-click unsubscribe (RFC 8058) — the ONE public unauthenticated
 * route besides health/webhooks. `GET /v1/email-unsubscribe?token=...` (the
 * visible footer link) and `POST` (mail providers' automated
 * List-Unsubscribe=One-Click POST) both flip `offerEmailsOptIn` to false for
 * the user owning the token.
 *
 * Token: per-user opaque random value (profiles.offer_emails_unsub_token),
 * generated lazily when the first alert email is sent — it authorizes exactly
 * this one action for exactly one user. No JWT, no session. An invalid or
 * missing token is a plain 404 with no information leak (never "token
 * expired" vs "unknown user").
 *
 * The success response is a tiny localized HTML confirmation page (not JSON):
 * the link is opened from a mail client by a human. Idempotent — repeating
 * the request with the same token returns the same page.
 */
export const EmailUnsubscribeQuerySchema = z.object({
    token: z.string().min(1).describe("Per-user opaque unsubscribe token from the email's unsubscribe link."),
});
/** text/html confirmation page ("Abgemeldet — keine Angebots-E-Mails mehr."). */
export const EmailUnsubscribeResponseSchema = z
    .string()
    .describe("Localized HTML confirmation page (text/html, not JSON).");
//# sourceMappingURL=emailUnsubscribe.js.map